const FORMAT_OPTIONS = {year: 'numeric', month: 'numeric', day: 'numeric'}

export default function formatDate(date: Date | string) {
  date = date instanceof Date ? date : new Date(date)
  return date.toLocaleDateString(undefined, FORMAT_OPTIONS)
}
